export default function (name) {
    return name
}

const fieldKey = {
    groupStatReadingDetailTableTitleText1_key: 'nickname',
    groupStatReadingDetailTableTitleText2_key: 'booksCnt',
    groupStatReadingDetailTableTitleText3_key: 'readingTime',
    groupStatReadingDetailTableTitleText4_key: 'bookNames',
    groupStatReadingDetailTableTitleText5_key: 'searchWordsCnt',
    groupStatReadingDetailTableTitleText6_key: 'searchWords',
    groupStatReadingDetailTableTitleText7_key: 'audiosCnt',
    groupStatReadingDetailTableTitleText8_key: 'jobsCnt',
    groupStatReadingDetailTableTitleText9_key: 'completedRate',
    groupStatReadingDetailTableTitleText10_key: 'coins',

    singleLookWordsTableHeaderText1_key: 'date',
    singleLookWordsTableHeaderText2_key: 'learnTimes',
    singleLookWordsTableHeaderText3_key: 'learnWords',
    singleLookWordsTableHeaderText4_key: 'learnBooks',

    singleFollowReadingTableHeaderText1_key: 'evalDate',
    singleFollowReadingTableHeaderText2_key: 'sentence',
    singleFollowReadingTableHeaderText3_key: 'score',
    singleFollowReadingTableHeaderText4_key: 'bookName',

    singleBoXueJiaTableHeaderText1_key: 'answerDate',
    singleBoXueJiaTableHeaderText2_key: 'question',
    singleBoXueJiaTableHeaderText3_key: 'answer',
    singleBoXueJiaTableHeaderText4_key: 'rightAnswer',
}


const zh = {
    ...fieldKey,
    qrCodeExpireText: '二维码失效，点击刷新',
    commonText1: '关键指标详解',
    commonText2: '排行榜',
    selectDateError: '请选择正确的时间范围！',
    netWorkError: '网络请求错误!',
    systemError: '系统错误!',
    headerTitle: '数据平台',
    headerLinkTitle1: '首页',
    headerLinkTitle2: '书库',
    headerLinkTitle3: '官网',

    payAlertTitle: 'WaWaYaYa爱读家SVIP',
    payAlertOpenTitle: '数据开放平台',
    payAlertOpenPermission0: '数据导出Excel表格',
    payAlertOpenPermission1: ' 自定义时间段查看数据',
    payAlertOpenPermission2: ' 博学家错题本',
    payAlertAppTitle: 'APP',
    payAlertAppPermission0: '3000+绘本随意阅读',
    payAlertAppPermission1: '儿歌故事想听就听',
    payAlertAppPermission2: '博学家双倍能量上限',
    payAlertAppPermission3: '完成任务领取更多WaWa币',
    payAlertAppPermission4: '专属身份标识',
    payAlertAppPermission5: '无限制收藏音频',
    payAlertText1: '更多特权，持续推出～',
    payAlertText3: '快扫描二维码去开通吧！',

    //登录页文字
    loginScanText1: '请使用',
    loginScanText3: '扫码登录',
    loginScanText5: '扫码成功，请在设备上授权登录',
    loginScanText7: '数据开放平台暂时只支持教师/管理员访问，您的账号为学生身份，敬请期待更新！',
    loginOutText: '退出登录',

    selectGroup: '切换团体版',
    selectSingle: '切换个人版',
    /********************************************团体版的文字***************************************/

    // 团体版左侧菜单文字
    groupLeftMenuText0: '综合',
    groupLeftMenuText1: '内容数据',
    groupLeftMenuText1_1: '阅读统计',
    groupLeftMenuText1_2: '阅读详情',
    groupLeftMenuText1_3: '榜单',
    groupLeftMenuText2: '行为数据',
    groupLeftMenuText2_1: '使用统计',
    groupLeftMenuText3: '功能数据',
    groupLeftMenuText3_1: '查词',
    groupLeftMenuText3_2: '跟读',
    groupLeftMenuText3_3: '故事魔瓶',
    groupLeftMenuText3_4: '博学家',


    exportText: '导出',
    noSelectScopeTipText: '请先选择数据范围！',
    selectScopeText: '选择数据范围',
    groupDataText: '团体数据',
    selectDataTypeText: '选择数据类型',
    scopeType_s: '学校',
    scopeType_c: '班级',
    scopeType_g: '小组',
    scopeType_u: '学生',
    selectText: '选择',
    seachText: '搜索',
    selectedScopeText_s: '已选学校',
    selectedScopeText_c: '已选班级',
    selectedScopeText_g: '已选小组',
    selectedScopeText_u: '已选学生',
    noSelectDataText: '暂无数据！',
    saveText: '完成',
    previousStepText: '上一步',
    nextStepText: '下一步',
    noSelectTipText: '请至少选择一个范围！',
    selectSuccessTipText: '保存数据范围成功',


    // 团体综合页
    groupHomeHeaderTipTitle: ['平均阅读量', '平均完成阅读', '平均阅读时长',
        '平均阅读图书', '平均浏览图书次数', '阅读倾向', '平均查词量', '平均跟读次数', '平均魔瓶被开启', '平均博学家通关数'],
    groupHomeHeaderTipContent: ['平均每个用户完成阅读的图书的总字数',
        '平均每个用户完整翻阅的图书数（每本书只记录一次）',
        '平均每个用户打开图书的次数',
        '平均每个用户阅读图书的时长',
        '平均每个用户打开过的图书数（每本书只记录一次）',
        '所有用户阅读过的图书当中哪些类型的图书占比最多',
        '平均每个用户使用词典功能，查询了多少个词汇（同一本书中每个词汇只记一次）',
        '平均每个用户使用跟读功能的次数',
        '平均每个用户发布的魔瓶，被开启次数',
        '平均每个用户博学家游戏通过了多少个关卡'],


    groupHomeModuleText1: '阅读情况',
    groupHomeReadingText: ['平均阅读量', '平均完成阅读', '平均阅读图书', '平均浏览图书次数', '平均阅读时长'],
    groupHomeReadingTrendText: '阅读倾向',

    groupHomeReadingTimeUnit0: '今日',
    groupHomeReadingTimeUnit1: '本周',
    groupHomeReadingTimeUnit2: '本月',

    groupHomeReadingDayUnit0: '字',
    groupHomeReadingDayUnit1: '本',
    groupHomeReadingDayUnit2: '分钟',
    groupHomeReadingDayUnit3: '次',

    groupHomeReadingMonthUnit0: '字',
    groupHomeReadingMonthUnit1: '本',
    groupHomeReadingMonthUnit2: '小时',

    groupHomeModuleText2: '各项功能情况',
    groupHomeFuncText0: '平均查词量',
    groupHomeFuncText1: '平均跟读次数',
    groupHomeFuncText2: '平均魔瓶被开启',
    groupHomeFuncText3: '平均博学家通关数',
    groupHomeFuncUnitText0: '次',
    groupHomeFuncUnitText1: '次',
    groupHomeFuncUnitText2: '关',
    groupHomeFuncUnitText3: '词',
    groupHomeModuleText3: '阅读排行榜',
    groupHomeModuleText5: '收听排行榜',
    groupHomeModuleText7: '通关排行榜',

    groupHomeRankingHeaderTitleText1: '用户',
    groupHomeRankingHeaderTitleText3: '阅读本数(本)',
    groupHomeRankingHeaderTitleText5: '阅读时长(小时)',
    groupHomeRankingHeaderTitleText9: '获得收听(次)',
    groupHomeRankingHeaderTitleText11: '创建魔瓶(个)',
    groupHomeRankingHeaderTitleText13: '通关数(关)',
    groupHomeRankingHeaderTitleText15: '获得星星(颗)',
    groupHomeRankingUnti1: '本',
    groupHomeRankingUnti3: '小时',
    groupHomeRankingUnti5: '次',
    groupHomeRankingUnti7: '个',
    groupHomeRankingUnti9: '关',
    groupHomeRankingUnti11: '颗',


    // 团体阅读统计页
    todayText: '今日',
    groupStatReadingTipTitle: ['平均阅读量', '平均完成阅读', '平均阅读图书', '平均浏览图书次数', '平均阅读时长', '阅读倾向'],
    groupStatReadingTipContent: ['平均每个用户完成阅读的图书的总字数',
        '平均每个用户完整翻阅的总图书数（每本书只记录一次）',
        '平均每个用户打开过的图书数（每本书只记录一次）',
        '平均每个用户打开图书的次数',
        '平均每个用户阅读图书的时长',
        '所有用户阅读过的图书当中哪些图书类型占比最多'],
    groupStatReadingChartUnit: ['字', '本', '本', '分钟'],


    // 团体阅读详情页
    selectTimeRangeText0: '今天',
    selectTimeRangeText1: '最近3天',
    selectTimeRangeText2: '最近7天',
    selectTimeRangeText3: '最近30天',
    selectTimeRangeText4: '选择日期',


    groupStatReadingDetailText1: '阅读报告',
    groupStatReadingDetailText2: '选择查看范围：',
    groupStatReadingDetailTableTitleText1: '姓名',
    groupStatReadingDetailTableTitleText2: '阅读本数',
    groupStatReadingDetailTableTitleText3: '阅读时间（分）',
    groupStatReadingDetailTableTitleText4: '阅读书目',
    groupStatReadingDetailTableTitleText5: '查词数',
    groupStatReadingDetailTableTitleText6: '查词内容',
    groupStatReadingDetailTableTitleText7: '跟读次数',
    groupStatReadingDetailTableTitleText8: '留作业次数',
    groupStatReadingDetailTableTitleText9: '作业完成率',
    groupStatReadingDetailTableTitleText10: '作业平均获得WaWa币',


    //团体榜单页
    groupRankHeaderTipTitle: ['阅读本数', '阅读时长', '查词量', '跟读次数', '获得收听量', '博学家通关数'],
    groupRankHeaderTipContent: ['打开过的图书数（每本书只记录一次）',
        '阅读图书的累计时长',
        '使用词典功能，查询了多少个词汇（每个词汇只记一次）',
        '使用跟读功能的次数',
        '发布的所有魔瓶，累计被开启次数',
        '博学家游戏通过了多少个关卡'],
    groupRankTypeText0: '书虫榜',
    groupRankTypeText1: '毅力榜',
    groupRankTypeText2: '查词榜',
    groupRankTypeText3: '跟读榜',
    groupRankTypeText4: '魔瓶收听榜',
    groupRankTypeText5: '博学家通关榜',
    groupRankTitleText0: '排名',
    groupRankTitleText1: '用户',
    groupRankTitleText2_0: '阅读本数(本)',
    groupRankTitleText2_1: '阅读时长(小时)',
    groupRankTitleText2_2: '查词量(词)',
    groupRankTitleText2_3: '跟读次数(次)',
    groupRankTitleText2_4: '获得收听量(次)',
    groupRankTitleText2_5: '博学家通关数(关)',

    //团体使用统计页面
    groupOnlineTipTitle:['平均使用时长','使用人数'],
    groupOnlineTipContent:['平均每个用户应用展示在设备前台的时长','使用过应用的人数（应用展示在设备前台算作进行使用）'],
    groupOnlineItem:['平均使用时长','使用人数'],
    groupOnlineText1:'趋势图',


    // 团体查词页面
    groupStatLookWordsHeaderTitle: '查词情况',

    groupStatLookWordsTipTitle: ['平均查词量', '查词倾向', '平均查词频率', '查询最频繁的词汇', '查词最多的图书', '词汇查询占比'],
    groupStatLookWordsTipContent: ['平均每个用户使用词典功能，查询了多少个词汇（每个词汇只记一次）',
        '所有用户所查词汇中，中文词与英文词的各自占比',
        '平均每个用户每次完整阅读一本书时，查询词汇次数（每个词汇只记一次）',
        '所有用户共同查询次数最多的词汇',
        '所有用户查询词汇数最多的图书（每个词汇只记一次）',
        '查询过的所有词汇中，每个词汇的查询次数占比'],
    groupStatLookWordsIndexText1: '平均查词量',
    groupStatLookWordsIndexText3: '查词倾向',
    groupStatLookWordsIndexText5: '平均查词频率',
    groupStatLookWordsIndexText7: '查询最频繁的词汇',
    groupStatLookWordsIndexText9: '查词最多的图书',

    groupStatLookWordsUnitText1: '词',
    groupStatLookWordsUnitText2chinese: '中文',
    groupStatLookWordsUnitText2english: '英文',
    groupStatLookWordsUnitText3: '词/本',

    groupStatLookWordsChartTitleText: '词汇查询占比',
    groupStatLookWordsChartSeriesName: '查询占比',

    //团体跟读页面
    groupStatFollowReadingHeaderTitle: '跟读情况',
    groupStatFollowReadingTipTitle1: '平均跟读次数',
    groupStatFollowReadingTipContent1: '平均每个用户使用跟读功能的次数',
    groupStatFollowReadingTipTitle2: '平均得分',
    groupStatFollowReadingTipContent2: '所有用户平均每一次跟读的得分',
    groupStatFollowReadingTipTitle3: '跟读倾向',
    groupStatFollowReadingTipContent3: '所有用户跟读内容中，内容的中英文占比',
    groupStatFollowReadingTipTitle4: '跟读次数最多的图书',
    groupStatFollowReadingTipContent4: '所有用户使用跟读功能次数最多的图书',

    groupStatFollowReadingIndexText0: '平均跟读次数',
    groupStatFollowReadingIndexText1: '平均单次得分',
    groupStatFollowReadingIndexText2: '跟读倾向',
    groupStatFollowReadingIndexText3: '跟读次数最多的图书',

    groupStatFollowReadingUnitText1: '次',
    groupStatFollowReadingUnitText3: '分',


    //魔瓶统计页面
    groupStatMbHeaderTitle: '魔瓶情况',
    groupStatMbHotListTitle: '最受欢迎的魔瓶',
    groupStatMbTipTitle1: '共创建魔瓶',
    groupStatMbTipContent1: '所有用户共创建的魔瓶数量',
    groupStatMbTipTitle2: '共累计被开启',
    groupStatMbTipContent2: '所有用户发布的所有魔瓶，累计被开启次数',
    groupStatMbTipTitle3: '共累计打开魔瓶',
    groupStatMbTipContent3: '所有用户共开启过的魔瓶数量',
    groupStatMbTipTitle4: '讲述最多的图书',
    groupStatMbTipContent4: '创建的魔瓶中，讲述次数最多的图书',
    groupStatMbAvgUserText: '平均每人',
    groupStatMbUnitText1: '个',
    groupStatMbUnitText3: '次',
    groupStatMbUnitText5: '的人讲过',
    groupStatMbIndexText1: '共创建魔瓶',
    groupStatMbIndexText3: '共累计被开启',
    groupStatMbIndexText5: '共累计打开魔瓶',
    groupStatMbIndexText7: '讲述最多的图书',
    groupStatMbAccessTimesText: '开启次数',

    /********************************************个人版的文字***************************************/

    // 个人版左侧菜单文字
    singleLeftMenuText0: '综合',
    singleLeftMenuText1: '内容数据',
    singleLeftMenuText1_1: '阅读树',
    singleLeftMenuText1_2: '阅读年报',
    singleLeftMenuText1_3: '中文分级',
    singleLeftMenuText1_4: '作业统计',
    singleLeftMenuText2: '行为数据',
    singleLeftMenuText2_1: '使用统计',
    singleLeftMenuText2_2: '我喜欢',
    singleLeftMenuText3: '功能数据',
    singleLeftMenuText3_1: '查词',
    singleLeftMenuText3_2: '跟读',
    singleLeftMenuText3_3: '故事魔瓶',
    singleLeftMenuText3_4: '博学家',
    singleLeftMenuText4: '极速识字',
    singleLeftMenuText4_1: '初始篇',

    // 综合页面
    singleHomeModuleText1: '阅读情况',
    singleHomeReadingText0: '阅读量',
    singleHomeReadingText1: '完成阅读',
    singleHomeReadingText2: '阅读时长',
    singleHomeReadingText5: '阅读图书',
    singleHomeReadingText7: '浏览图书次数',
    singleHomeReadingTrendText: '阅读倾向',

    singleHomeReadingTimeUnit0: '本日',
    singleHomeReadingTimeUnit1: '本周',
    singleHomeReadingTimeUnit2: '本月',

    singleHomeReadingDayUnit0: '字',
    singleHomeReadingDayUnit1: '本',
    singleHomeReadingDayUnit2: '分钟',
    singleHomeReadingDayUnit3: '次',

    singleHomeReadingMonthUnit0: '字',
    singleHomeReadingMonthUnit1: '本',
    singleHomeReadingMonthUnit2: '小时',

    singleHomeModuleText2: '各项功能情况',
    singleHomeFuncText0: '查词量',
    singleHomeFuncText1: '跟读次数',
    singleHomeFuncText2: '魔瓶被打开',
    singleHomeFuncText3: '博学家通关数',
    singleHomeFuncUnitText0: '词',
    singleHomeFuncUnitText1: '次',
    singleHomeFuncUnitText2: '关',

    readingBookRatioText: '阅读图书占比',
    readingBookRatio_chinese: '中文',
    readingBookRatio_english: '英文',
    readingBookPreferenceText: '阅读图书偏好',
    readingBookPreferenceRadio_0: '最近一年',
    readingBookPreferenceRadio_1: '所有时间',

    singleHomeTipTitle: ['阅读量', '完成阅读', '阅读时长', '阅读图书', '浏览图书次数', '阅读倾向',
        '查词量', '跟读次数', '魔瓶被打开', '博学家通关数', '阅读图书占比', '阅读图书偏好'],
    singleHomeTipContent: ['所有完成阅读的图书的总字数', '完整翻阅过的图书数（每本书只记录一次）',
        '阅读图书的累计时长', '打开过的图书数（每本书只记录一次）', '打开图书的次数', '阅读图书当中占比最多的图书类型',
        '使用词典功能，查询了多少个词汇（同一本书中每个词汇只记一次）', '使用跟读功能的次数', '用户发布的所有魔瓶，累计被开启次数',
        '博学家游戏通过了多少个关卡', '阅读图书的语言类别占比', '阅读图书当中各图书类型的占比情况'],


    // 阅读树页面
    singleReadingTreeTipTitle: ['阅读量', '完成阅读', '阅读图书', '浏览图书次数', '阅读时长', '阅读倾向'],
    singleReadingTreeTipContent: ['所有完成阅读的图书的总字数',
        '完整翻阅过的图书数（每本书只记录一次）',
        '打开过的图书数（每本书只记录一次）',
        '打开图书的次数',
        '阅读图书的累计时长',
        '阅读图书当中占比最多的图书类型'],
    readingTreeDetailText: '详细数据',


    readingTreeDetailUnit1: '本',
    readingTreeDetailUnit3: '分钟',
    readingTreeDetailUnit5: '小时',


    // 阅读年报页面
    singleReadingYearReportTipTitle: ['阅读量', '完成阅读', '阅读图书', '浏览图书次数',
        '阅读时长', '阅读倾向', '阅读本数统计', '图书浏览次数统计'],
    singleReadingYearReportTipContent: ['所有完成阅读的图书的总字数',
        '完整翻阅过的图书数（每本书只记录一次）',
        '打开过的图书数（每本书只记录一次）',
        '打开图书的次数',
        '阅读图书的累计时长',
        '阅读图书当中占比最多的图书类型',
        '每个月阅读图书的数量（每本书月内只记录一次）',
        '图书的打开次数排行'],
    singleReadingYearReportMainTitle: '阅读情况',
    singleReadingYearReportText1: '阅读本数统计',
    singleReadingYearReportText3: '阅读冠军日',
    singleReadingYearReportText5: '录制故事',
    singleReadingYearReportText7: '最爱图书 Top3',
    singleReadingYearReportText11: '这一天共读了@本书',
    singleReadingYearReportText13: '在这一年里你讲了@个故事',
    singleReadingYearReportText16: "字",
    singleReadingYearReportText19: "图书浏览次数统计",
    singleReadingYearReportText21:'浏览图书次数',
    singleReadingYearReportText23:'次',


    // 中文分级页面
    singleChineseLevelTipTitle1: '阅读图书占比',
    singleChineseLevelTipContent1: '阅读图书的语言类别占比',
    singleChineseLevelTipTitle2: '阅读图书等级分布',
    singleChineseLevelTipContent2: '阅读图书的所属等级占比',
    singleChineseLevelText1: '阅读图书等级分布',

    //学生作业统计页面
    singleJobTitle: '作业情况',
    singleStuJobTipTitle1: '完成作业',
    singleStuJobTipContent1: '完成作业的次数',
    singleStuJobTipTitle2: '作业完成率',
    singleStuJobTipContent2: '完成作业次数/收到作业次数',
    singleStuJobTipTitle3: '完成作业类型比例',
    singleStuJobTipContent3: '完成的作业当中，阅读类和朗读/复述类的占比',
    singleStuJobTipTitle4: '作业获得WaWa币',
    singleStuJobTipContent4: '完成作业共获得了多少WaWa币',
    singleJobText1: '次',
    singleJobText2: '阅读',
    singleJobText3: '个',
    singleJobText4: '朗读',
    singleJobText5: '作业详情',
    singleJobText6: '全部',
    singleJobText7: '需阅读@本',
    singleJobText9: '需朗读/复述@本',
    singleJobText11: '已完成',
    singleJobText13: '未完成',
    singleJobText15: '过期',


    //教师留作业统计页面
    singleTchJobTipTitle1: '布置作业次数',
    singleTchJobTipContent1: '作为教师布置作业的次数',
    singleTchJobTipTitle2: '学生作业完成率',
    singleTchJobTipContent2: '学生作业完成率',
    singleTchJobTipTitle3: '布置作业类型比例',
    singleTchJobTipContent3: '布置的作业当中，阅读类和朗读/复述类的占比',
    singleTchJobTipTitle4: '我管理的班级/小组',
    singleTchJobTipContent4: '管理了多少个班级、多少个小组',
    singleTchJobText1: '班级',
    singleTchJobText3: '小组',
    singleTchJobText5: '个',
    singleTchJobText7: '人',
    singleTchJobText9: '已完成（@人）',
    singleTchJobText11: '未完成（@人）',

    // 在线统计页面
    singleOnlineTipTitle:['使用时长'],
    singleOnlineTipContent:['应用展示在设备前台的时长'],
    singleOnlineItem:['使用时长'],
    singleOnlineText1:'趋势图',

    //查词页面
    singleLookWordsTipTitle: ['查词量', '查词倾向', '查词频率', '查词最多的图书', '查词排行'],
    singleLookWordsTipContent: ['使用词典功能，查询了多少个词汇（每个词汇只记一次）',
        '所查词汇中，中文词与英文词的各自占比',
        '平均每次完整阅读一本书时，查询了多少个词汇（每个词汇只记一次）',
        '查询词汇数最多的图书（每个词汇只记一次）',
        '词汇的查询次数排行'],
    singleLookWordsText1: '查词情况',
    singleLookWordsText3: '次',
    singleLookWordsText5: '词/本',
    singleLookWordsText7: '中文',
    singleLookWordsText9: '英文',
    singleLookWordsTableHeaderText1: '日期',
    singleLookWordsTableHeaderText2: '查词次数',
    singleLookWordsTableHeaderText3: '查询词汇',
    singleLookWordsTableHeaderText4: '查词图书',
    singleLookWordsText11: '查词明细',
    singleLookWordsText13: '查词排行',

    // 跟读页面
    singleFollowReadingTipTitle: ['跟读次数', '平均得分', '跟读倾向', '跟读次数最多的图书', '跟读排行'],
    singleFollowReadingTipContent: ['使用跟读功能的次数',
        '平均每一次跟读的得分', '跟读内容的中英文占比', '使用跟读功能次数最多的图书', '句子的跟读次数排行'],
    singleFollowReadingText1: '跟读情况',
    singleFollowReadingText3: '次',
    singleFollowReadingText5: '分',
    singleFollowReadingText7: '中文',
    singleFollowReadingText9: '英文',
    singleFollowReadingTableHeaderText1: '日期',
    singleFollowReadingTableHeaderText2: '跟读内容',
    singleFollowReadingTableHeaderText3: '得分',
    singleFollowReadingTableHeaderText4: '所属图书',
    singleFollowReadingText11: '跟读排行',
    singleFollowReadingText13: '跟读明细',


    // 故事魔瓶页面
    singleMbTipTitle1: '创建魔瓶',
    singleMbTipContent1: '用户创建的魔瓶数量',
    singleMbTipTitle2: '累计被开启',
    singleMbTipContent2: '用户发布的所有魔瓶，累计被开启次数',
    singleMbTipTitle3: '打开他人魔瓶',
    singleMbTipContent3: '收听他人魔瓶次数',
    singleMbTipTitle4: '讲述最多的图书',
    singleMbTipContent4: '创建的魔瓶中，讲述次数最多的图书',
    singleMbPrimaryTitle: '我的魔瓶情况',
    singleMbText1: '我创建的魔瓶',
    singleMbText3: '开启次数',
    singleMbText5: '次',
    singleMbText7: '你还没有故事魔瓶，快去APP制造一个吧！',
    singleMbText9: '个',


    // 博学家页面
    singleBoXueJiaTipTitle1: '通关数',
    singleBoXueJiaTipContent1: '博学家游戏通过了多少个关卡（重复通关相同关卡不计算）',
    singleBoXueJiaTipTitle2: '累计获得星星',
    singleBoXueJiaTipContent2: '博学家游戏中累计获得的星星数',
    singleBoXueJiaTipTitle3: '平均通关用时间',
    singleBoXueJiaTipContent3: '平均每次通过关卡所用时',
    singleBoXueJiaTipTitle4: '答题正确率',
    singleBoXueJiaTipContent4: '博学家游戏当中的答题正确率（正确次数/总答题次数）',
    singleBoXueJiaPrimaryTitle: '我的博学家情况',
    singleBoXueJiaText1: '关',
    singleBoXueJiaText3: '颗',
    singleBoXueJiaText5: '秒',
    singleBoXueJiaText7: '错题本',
    singleBoXueJiaText9: '立即开通',
    singleBoXueJiaText11: '查看正确答案为SVIP功能',
    singleBoXueJiaText13: '是否显示重复错题',
    singleBoXueJiaTableHeaderText1: '日期',
    singleBoXueJiaTableHeaderText2: '题目',
    singleBoXueJiaTableHeaderText3: '我的答案',
    singleBoXueJiaTableHeaderText4: '正确答案',


    // 极速识字初始篇
    singleFlashCardFirstTitle: '极速识字——初始篇',
    singleFlashCardFirstMainTitle: '初识篇学习情况',
    singleFlashCardFirstMainTip: ['通关数', '汉字通学完数量', '说一说平均得分', '小聆龙识字次数', '小聆龙听音找字正确率'],
    singleFlashCardFirstMainUnit: ['关', '字', '分', '次'],
    singleFlashCardFirstMainKey: ['passedCheckpoints', 'lccWords', 'avgScoreSpeaking', 'lrTimes', 'lfAccuracyRating'],
    singleFlashCardFirstItemType: ['汉字通', '说一说', '小聆龙识字', '小聆龙听音找字'],
    singleFlashCardFirstHeaderTipTitle: ['通关数', '累计获得星星', '说一说平均得分', '小聆龙识字次数', '小聆龙听音找字正确率'],
    singleFlashCardFirstHeaderTipContent: ['初识篇通过了多少个关卡（重复通关相同关卡不计算）',
        '初识篇获得的星星数量',
        '说一说游戏中，朗读例句的平均得分',
        '使用小聆龙识别汉字卡片的次数（仅统计初识篇字卡，包含重复识别',
        '小聆龙听音找字游戏中的答题正确率（正确寻找次数÷总寻找次数）'],
    singleFlashCardFirstDataType: ['最常学习Top10', '说一说', '最常识别Top10', '小聆龙听音找字'],
    singleFlashCardFirstSpeakingTableColumnTitle: ['日期', '所学汉字', '朗读内容', '得分'],
    singleFlashCardFirstSpeakingTableColumnKey: ['learningDate', 'word', 'sentence', 'score'],
    singleFlashCardFirstLfTableColumnTitle: ['日期', '开启关卡', '关卡题目', '找字正确率',],
    singleFlashCardFirstLfTableColumnKey: ['learningDate', 'cpTitle', 'words', 'rating'],

}


const en = {
    netWorkError: 'Network request error!',

    headerTitle: '数据平台',
    headerLinkTitle1: '首页',
    headerLinkTitle2: '书库',
    headerLinkTitle3: '官网',
    teamLeftMenuText0: '综合',
    teamLeftMenuText1: '内容数据',
    teamLeftMenuText1_1: '阅读统计',
    teamLeftMenuText1_2: '阅读详情',
    teamLeftMenuText1_3: '榜单',
    teamLeftMenuText2: '行为数据',
    teamLeftMenuText2_1: '在线统计',
    teamLeftMenuText3: '功能数据',
    teamLeftMenuText3_1: '查词',
    teamLeftMenuText3_2: '跟读',
    teamLeftMenuText3_3: '故事魔瓶',
    teamLeftMenuText3_4: '博学家',

    groupStatReadingTipTitle1: '平均阅读量1',
    groupStatReadingTipContent1: '平均每个用户阅读的总字数',
    groupStatReadingTipTitle2: '平均完成阅读',
    groupStatReadingTipContent2: '平均每个用户阅读完成的总图书数',
    groupStatReadingTipTitle3: '平均阅读时长',
    groupStatReadingTipContent3: '平均每个用户阅读图书的总时长',
    groupStatReadingTipTitle4: '阅读倾向',
    groupStatReadingTipContent4: '所有用户阅读过的图书当中哪些类型占比最多',


}

const dflang = zh

export function lang(key, language) {
    var value = null
    if (language === 'zh') {
        value = zh[key]
    } else if (language === 'en') {
        value = en[key]
    }
    if (value == null) {
        value = dflang[key]
    }
    return value
}

export function ipCtr(key, language) {
    var value = null
    if (language === 'CN') {
        value = zh[key]
    } else {
        value = en[key]
    }
    return value
}

